// extracted by mini-css-extract-plugin
export var falconContainer = "_tq-2";
export var offerCenter = "_tq-0";
export var roktContainer = "_tq-1";